import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import './TypeFilter.css'
export default function SecondHardwareFilter() {
    const [hardware, setHardware] = useState('');

    const handleChange = (event) => {
        setHardware(event.target.value);
    };

    return (
        <div className='HardwareFilterContainer'>
            <FormControl variant="standard" sx={{ m: 2, minWidth: 120 }}>
                <InputLabel id="demo-simple-select-standard-label">Tipo de licença</InputLabel>
                <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={hardware}
                    onChange={handleChange}
                    label="Name"
                >
                    <MenuItem value="">
                        <em>Todas</em>
                    </MenuItem>
                    <MenuItem value={1}>T100-Historian-vitalicio</MenuItem>
                    <MenuItem value={2}>T500-PiD-1ANO</MenuItem>
                    <MenuItem value={3}>T1000-Historian-2ANOS</MenuItem>
                    <MenuItem value={4}>T100-PID-6MESES</MenuItem>
                </Select>
            </FormControl>
        </div>
    )

}


